import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost';
const PORT = process.env.REACT_APP_API_PORT || '4000';

const cleanURL = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL;

const finalURL = (PORT === '80' || PORT === '443' || !PORT) 
    ? `${cleanURL}/api` 
    : `${cleanURL}:${PORT}/api`;

const api = axios.create({
    baseURL: finalURL,
    // headers: {
    //     'Content-Type': 'application/json',
    // },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const setupResponseInterceptor = (handleLogout) => {
    const interceptor = api.interceptors.response.use(
        (response) => response,
        (error) => {
            const { response } = error;
            if (response && (response.status == 401 || response.status == 403)) {
                const message = response.data?.code?.toLowerCase() || '';
                const errorDetail = response.data?.error?.toLowerCase() || '';

                if (message.includes('expired') || message.includes('invalid') || errorDetail.includes('expirado') || errorDetail.includes('inválido')) {
                    handleLogout();
                }
            }
            return Promise.reject(error);
        }
    );
    return interceptor;
};

export default api;